import { api } from "@/lib/api";
import type { Album, Artist, HomeFeed, Paged, Playlist, Track } from "@/types/types";

export const musicService = {
  home: () => api<HomeFeed>("/api/home"),
  artists: (offset = 0, limit = 50) => api<Paged<Artist>>(`/api/catalog/artists?offset=${offset}&limit=${limit}`),
  artist: (id: string) => api<Artist>(`/api/catalog/artists/${id}`),
  artistAlbums: (id: string) => api<Paged<Album>>(`/api/catalog/artists/${id}/albums`),
  artistTopTracks: (id: string) => api<Track[]>(`/api/catalog/artists/${id}/top-tracks`),
  album: (id: string) => api<Album>(`/api/catalog/albums/${id}`),
  albumTracks: (id: string) => api<Track[]>(`/api/catalog/albums/${id}/tracks`),
  track: (id: string) => api<Track>(`/api/catalog/tracks/${id}`),
  playlist: (id: string) => api<Playlist>(`/api/library/playlists/${id}`),
  playlistTracks: (id: string) => api<Track[]>(`/api/library/playlists/${id}/tracks`),
  playlists: () => api<Paged<Playlist>>(`/api/library/playlists`),
  createPlaylist: (name: string, is_public = false) =>
    api<Playlist>(`/api/library/playlists`, { method: "POST", body: JSON.stringify({ name, is_public }) }),
  deletePlaylist: (id: string) => api<void>(`/api/library/playlists/${id}`, { method: "DELETE" }),
  addToPlaylist: (id: string, trackIds: string[]) =>
    api<void>(`/api/library/playlists/${id}/tracks`, {
      method: "POST",
      body: JSON.stringify({ track_ids: trackIds }),
    }),
  addTracksToPlaylist: (id: string, trackIds: string[]) =>
    api<void>(`/api/library/playlists/${id}/tracks`, {
      method: "POST",
      body: JSON.stringify({ track_ids: trackIds }),
    }),
  topTracks: (period: "day" | "week" | "month" | "year" | "all" = "month", limit = 15) =>
    api<Array<{ plays: number; track: Track }>>(
      `/api/stats/top/tracks?period=${period}&limit=${limit}`,
    ),
  bangersForMe: (limit = 15, opts?: { fresh?: boolean; exclude?: string[] }) =>
    api<Array<{
      id: string; title: string; duration_ms: number; popularity: number;
      artist: { id: string; name: string };
      album: { id: string; title: string; image_url: string | null };
    }>>(
      `/api/recommend/bangers-for-me?limit=${limit}` +
      (opts?.fresh ? `&nonce=${Date.now()}` : "") +
      (opts?.exclude?.length ? `&exclude=${encodeURIComponent(opts.exclude.join(","))}` : ""),
    ),
  /** Tracks that fit a selection (smart shuffle / "Enrichir"). */
  forTracks: (trackIds: string[], excludeIds: string[] = [], limit = 20) =>
    api<Track[]>(`/api/recommend/for-tracks`, {
      method: "POST",
      body: JSON.stringify({ track_ids: trackIds, exclude_ids: excludeIds, limit }),
    }),
  toggleLibrary: (kind: "artist" | "album" | "track" | "playlist", ref_id: string) =>
    api<void>(`/api/library/toggle`, { method: "POST", body: JSON.stringify({ kind, ref_id }) }),
  likedTracks: (offset = 0, limit = 200) =>
    api<Paged<Track>>(`/api/library/liked/tracks?offset=${offset}&limit=${limit}`),
  likedAlbums: (offset = 0, limit = 200) =>
    api<Paged<Album>>(`/api/library/liked/albums?offset=${offset}&limit=${limit}`),
  likedArtists: (offset = 0, limit = 200) =>
    api<Paged<Artist>>(`/api/library/liked/artists?offset=${offset}&limit=${limit}`),
};
